module.exports = __webpack_public_path__ + "static/media/united-cloud.2163a29f.svg";